(function () {
    'use strict';

    angular
        .module('crewing')
        .controller('SendNotificationCtrl', SendNotificationCtrl);

    function SendNotificationCtrl($uibModalInstance, $http, modalParams, MessageService) {
        var vm = this;

        var defaultMessage = '';
        if (modalParams.blockName) {
            defaultMessage = modalParams.blockName +
                ' CHECK-IN: ' + (modalParams.checkInDate || '') + ' ' + (modalParams.checkInTime || '') + '(L)' +
                ' CHECK-OUT: ' + (modalParams.checkOutDate || '') + ' ' + (modalParams.checkOutTime || '') + '(L)';
        }

        vm.model = {
            crewDetails: (modalParams.joiningCrew || []).map(function (crew) {
                return {
                    crewProfileId: crew.crewProfileId,
                    crewSchdBlockId: crew.crewSchdBlockId,
                    crewName: (crew.firstName || '') + ' ' + (crew.lastName || ''),
                    crewTypeCode: crew.crewTypeCode,
                    mobileNumber: crew.mobileNumber,
                    signInDate: crew.signInDate,
                    signInTime: crew.signInTime,
                    signOutDate: crew.signOutDate,
                    signOutTime: crew.signOutTime,
                    isChecked: false
                };
            }),
            allChecked: false,
            message: defaultMessage,
            channelE: true,
            channelN: true,
            channelS: true,
            channelC: true,
            loading: false
        };

        vm.onChannelNChange = function () {
            vm.model.channelC = vm.model.channelN;
        };

        vm.onChannelCChange = function () {
            vm.model.channelN = vm.model.channelC;
        };

        vm.toggleSelectAll = function () {
            vm.model.allChecked = !vm.model.allChecked;
            angular.forEach(vm.model.crewDetails, function (crew) {
                crew.isChecked = vm.model.allChecked;
            });
        };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        vm.onSend = function () {
            var selectedCrew = vm.model.crewDetails.filter(function (c) { return c.isChecked; });
            if (selectedCrew.length === 0) {
                MessageService.warning('Please select at least one crew member.');
                return;
            }

            var channels = [];
            if (vm.model.channelE) channels.push('E');
            if (vm.model.channelN) channels.push('N');
            if (vm.model.channelS) channels.push('S');
            if (vm.model.channelC) channels.push('C');
            if (channels.length === 0) {
                MessageService.warning('Please select at least one notification channel.');
                return;
            }

            if (!vm.model.message || !vm.model.message.trim()) {
                MessageService.warning('Please enter a message.');
                return;
            }

            vm.model.loading = true;

            var payload = {
                crewList: selectedCrew.map(function (c) {
                    return { crewProfileId: c.crewProfileId, crewSchdBlockId: c.crewSchdBlockId };
                }),
                content: vm.model.message.trim(),
                appendLink: false,
                expireIn: 15,
                channel: channels
            };

            $http.post('/admin/aeroLineCrewAdmin/linkVerify/send/sms', payload)
                .then(function (response) {
                    if (response.data && response.data.success) {
                        MessageService.success('Notification sent successfully.');
                        $uibModalInstance.close('SUCCESS');
                    } else {
                        MessageService.error('Error occurred while sending notification.');
                    }
                }, function () {
                    MessageService.error('Error occurred while sending notification.');
                })
                .finally(function () {
                    vm.model.loading = false;
                });
        };
    }

}());
